import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { syncPreviewFromUrl } from './app/preview/preview.util';

// PREVIEW MODE toggle (?preview=1 / ?preview=0) — must run before bootstrap
syncPreviewFromUrl();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
